import RegisterForm from './RegisterForm';
import { RoleNames } from '@/enums';

function OrganizationRegister() {
  return <RegisterForm roleName={RoleNames.ORG_ADMIN} />;
}

export default OrganizationRegister;
